import { ListBlockType } from "@components/ListBlock/queries/contentfulTypes/ListBlockType";
import { stringifyListItems } from "@utils/listHelpers/listBlockHelpers";
import { getManualPages, getOrderedAutoSelectedPages } from "@utils/listHelpers/pageFetchers";

import { ListItem, PaginationContainer } from "types/ListItem";
import { UrlStructure } from "types/UrlStructure";

export const getResultForListBlock = async (
  { listBlock }: ListBlockType,
  paginationPage = 1,
  preview: boolean,
  urlStructure: UrlStructure,
): Promise<PaginationContainer> => {
  let uniqueAutoSelectedPages = new Array<ListItem>();

  const manualPages = getManualPages(listBlock?.manualPostsCollection?.items, urlStructure);

  if (listBlock?.contentTypes && listBlock?.contentTypes?.length > 0) {
    const autoSelectedPages = await getOrderedAutoSelectedPages(listBlock, preview, urlStructure);

    //clears manually selected posts from automatic list
    uniqueAutoSelectedPages = autoSelectedPages?.filter(
      (page: ListItem) => !manualPages?.some((manualPage: ListItem) => manualPage?.id === page?.id),
    );
  }

  const totalItems = [].concat(manualPages, uniqueAutoSelectedPages) as Array<ListItem>;

  let pages = [];
  if (!listBlock.pagination && listBlock?.numberOfItems < pages.length) {
    pages = totalItems?.slice(0, listBlock?.numberOfItems);
  } else {
    pages = totalItems?.slice(
      listBlock?.numberOfItems * (paginationPage - 1),
      listBlock?.numberOfItems * (paginationPage - 1) + listBlock?.numberOfItems,
    );
  }

  const result = stringifyListItems(pages);

  return {
    listResult: result,
    totalItems: totalItems.length,
  } as PaginationContainer;
};
